import React, { useEffect, useState } from "react";
import {
  useIndeeApiChecked,
  useScreenerLoggedIn,
  setDisplayScreenerLogin,
  setDisplayScreenerProjectList,
  useActiveProjectKey,
  setActiveProjectKey,
  setActiveTitleName,
} from "../../../../utils/Screeners/useScreeners";
import Moment from "react-moment";
import { stopAllPageMedia } from "../../../../utils/Actions/stopAllPageMedia";

export default function WatchNowButton({ showData }) {
  const indeeApiChecked = useIndeeApiChecked();
  const screenerLoggedIn = useScreenerLoggedIn();
  const activeProjectKey = useActiveProjectKey();
  const [availableOn, setAvailableOn] = useState(null);
  const [releaseDate, setReleaseDate] = useState(null);
  const [releaseDateHasPassed, setReleaseDateHasPassed] = useState(false);

  useEffect(() => {
    // console.log(showData);
    setActiveProjectKey(showData?.indee_project_key);
    setAvailableOn(showData?.available_on);
  }, [showData]);

  useEffect(() => {
    let subscribed = true;
    if (subscribed && availableOn) {
      Moment.globalLocale = "en-us";
      let tempDate = new Date(availableOn);
      tempDate.setDate(tempDate.getDate() + 1);
      tempDate.setHours(0, 0, 0, 0);
      setReleaseDate(tempDate);
      setReleaseDateHasPassed(dateHasPassed(availableOn));
    }
    return () => {
      subscribed = false;
    };
  }, [availableOn]);

  const dateHasPassed = (titleReleaseDate) => {
    const nowDate = new Date();
    let compareDate = new Date(titleReleaseDate);
    compareDate.setDate(compareDate.getDate() + 1);
    compareDate.setHours(0, 0, 0, 0);
    // console.log('dateHasPassed',nowDate, compareDate, nowDate >= compareDate)
    return nowDate >= compareDate;
  };

  return (
    <div className="show-watchnow">
      {releaseDate && releaseDateHasPassed && showData?.indee_project_key ? (
        <button
          className={
            "show-watch-now-button screenerButton " +
            (!indeeApiChecked ? "screenerButtonLoading" : "")
          }
          onClick={() => {
            stopAllPageMedia();
            setActiveTitleName(showData.title);
            if (screenerLoggedIn) {
              setDisplayScreenerProjectList(true);
            } else {
              setDisplayScreenerLogin(true);
            }
          }}
        >
          Watch Now
        </button>
      ) : releaseDate && !releaseDateHasPassed ? (
        <span
          className={"py-4"}
          style={{
            fontSize: ".8rem",
            textTransform: "uppercase",
            letterSpacing: ".2rem",
          }}
        >
          Available <Moment format="MMMM DD, YYYY">{releaseDate}</Moment>
        </span>
      ) : !releaseDate && !showData?.indee_project_key ? (
        <></>
      ) : (
        <span
          className={"py-4"}
          style={{
            fontSize: ".8rem",
            textTransform: "uppercase",
            letterSpacing: ".2rem",
          }}
        >
          Coming Soon ...
        </span>
      )}
    </div>
  );
}
